<xemex-dialog-shell
  [title]="'installations.editor.unbind.title' | translate: { point: point?.name ?? '' }"
>
  <div class="flex flex-col gap-4">
    <p class="m-0">
      {{ 'installations.editor.unbind.lead' | translate: { source: source } }}
    </p>
    <xemex-effective-from-field
      [(instant)]="instant"
      [timeZone]="data.timeZone"
      [error]="messageAt('instant')"
    />
    @if (messageAt('action') ?? messageAt('dialog'); as messageKey) {
      <p class="m-0 text-text-error" role="alert">{{ messageKey | translate }}</p>
    }
  </div>

  <div actions class="flex w-full items-center justify-end gap-3">
    <xemex-text-button (click)="cancel()">
      {{ 'general.btnCancel' | translate }}
    </xemex-text-button>
    <xemex-filled-button
      intent="destructive"
      [disabled]="isSaving() || stale()"
      [loading]="isSaving()"
      (click)="unbind()"
    >
      {{ 'installations.editor.unbind.confirm' | translate }}
    </xemex-filled-button>
  </div>
</xemex-dialog-shell>
